import {Link} from "react-router-dom";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import axios from "axios";
import {baseUrl} from '../Univ.js'
function MisMenu() {
    const handleBackup = async () => {
        const response = await axios.get(baseUrl + 'backup/', {responseType: 'blob'})
        const blob = new Blob([response.data])
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = "backup.sql"
        link.click()
    }
    const handleRestore = async (e) => {
        const formData = new FormData()
        formData.append('backup_file', e.target.files[0])
        await axios.post(baseUrl + 'restore/', formData)
        alert("Database restored successfully")
    }
    const MenuCard = ({link, title, icon, color}) => (
        <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
            <Link to={link} className="menu-link">

                <div className="menu-card" style={{borderTop: `4px solid ${color}`}}>
                    <div className="menu-icon" style={{color: color}}>
                        <FontAwesomeIcon icon={icon} size="2x"/>
                    </div>

                    <p className="menu-title">{title}</p>

                </div>
            </Link>
        </div>
    )
    return (
        <section className="container-fluid mt-4">

            <h5 className="menu-section-title">MIS</h5>

            <div className="row">

                <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
                    <div className="menu-card" onClick={handleBackup}>
                        <p className="menu-title">Backup Database</p>
                    </div>
                </div>

                <div className="col-xl-3 col-lg-4 col-md-6 mb-4">
                    <input type="file" onChange={handleRestore}/>
                </div>

                <MenuCard link="/mis-collection" title="MIS Dashboard" icon="fa-solid fa-chart-line" color="#0d6efd"/>

            </div>


            <h5 className="menu-section-title">Cashier OP Reports</h5>

            <div className="row">

                <MenuCard link="/payment-detail" title="Payment Detail Report" icon="fa-solid fa-file-invoice"
                          color="#0d6efd"/>
                <MenuCard link="/collection-all" title="Collection Detail Report" icon="fa-solid fa-chart-column"
                          color="#20c997"/>
                <MenuCard link="/collection-credit" title="Credit Pay Report" icon="fa-solid fa-credit-card"
                          color="#6f42c1"/>
                <MenuCard link="/due-report" title="Patient Due Report" icon="fa-solid fa-clock" color="#fd7e14"/>
                <MenuCard link="/pending-bills" title="Pending Bills Report" icon="fa-solid fa-file-circle-xmark"
                          color="#dc3545"/>
                <MenuCard link="/collection-op" title="OP Collection Report" icon="fa-solid fa-hospital-user"
                          color="#198754"/>
                <MenuCard link="/collection-lab" title="Lab Collection Report" icon="fa-solid fa-vial" color="#0dcaf0"/>
                <MenuCard link="/collection-inv" title="Investigation Collection" icon="fa-solid fa-x-ray"
                          color="#6610f2"/>
                <MenuCard link="/collection-min" title="Minor Treatment Collection" icon="fa-solid fa-syringe"
                          color="#d63384"/>
                <MenuCard link="/refund-report" title="Refund Report" icon="fa-solid fa-rotate-left" color="#fd7e14"/>
                <MenuCard link="/cons-pay-report" title="Consultant Payment Report" icon="fa-solid fa-user-doctor"
                          color="#0d6efd"/>
                <MenuCard link="/discount-report" title="Discount Report" icon="fa-solid fa-percent" color="#20c997"/>
                <MenuCard link="/expense-report" title="Expense Report" icon="fa-solid fa-wallet" color="#dc3545"/>

            </div>


            <h5 className="menu-section-title">IP Reports</h5>

            <div className="row">

                <MenuCard link="/payment-detail-ip" title="IP Payment Detail" icon="fa-solid fa-file-invoice-dollar"
                          color="#0d6efd"/>
                <MenuCard link="/insur-report" title="Insurance Report" icon="fa-solid fa-shield-heart"
                          color="#20c997"/>
                <MenuCard link="/admit-list-date" title="Admission List" icon="fa-solid fa-bed" color="#6f42c1"/>
                <MenuCard link="/discharge-list-date" title="Discharge List" icon="fa-solid fa-door-open"
                          color="#fd7e14"/>
                <MenuCard link="/ip-refund-report-view" title="Refund Report Date" icon="fa-solid fa-rotate-left"
                          color="#dc3545"/>

            </div>

        </section>
    )
}
export default MisMenu;